(() => {
	// _src/snippets/header/header.js
	document.addEventListener('DOMContentLoaded', function () {
		const toggleButton = document.querySelector('[data-toggle-menu]');
		const menu = toggleButton.closest('header');
		if (toggleButton && menu) {
			toggleButton.addEventListener('click', function () {
				menu.classList.toggle('is-active');
			});
		}
		window.addEventListener('scroll', function () {
			if (menu.classList.contains('is-active')) {
				menu.classList.remove('is-active');
			}
		});
		subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
			const cartData = event.cartData;
			const itemCount = cartData.item_count || cartData.quantity || 0;
			const bagCounter = document.querySelectorAll('[data-cart-count]');
			if (bagCounter) {
				bagCounter.forEach((el) => {
					el.textContent = itemCount;
				});
			}
		});
		const cartTriggers = document.querySelectorAll('.js-cart');
		cartTriggers.forEach((trigger) => {
			trigger.addEventListener('click', function (event) {
				event.preventDefault();
				document.querySelector('cart-drawer')?.open();
			});
		});
	});
})();
